import Products from 'merchandise-lib/constants/Product';
const VALID_API_NAMES_FOR_CORE_SEAT = [Products.MARKETING_HUB_PROFESSIONAL, Products.MARKETING_HUB_ENTERPRISE, Products.OPERATIONS_HUB_PROFESSIONAL, Products.OPERATIONS_HUB_ENTERPRISE, Products.CMS_HUB_PROFESSIONAL, Products.CMS_HUB_ENTERPRISE, Products.CRM_SUITE_STARTER_BUNDLE, Products.CRM_SUITE_PROFESSIONAL_BUNDLE, Products.CRM_SUITE_ENTERPRISE_BUNDLE, Products.CORE_SEATS_PROFESSIONAL, Products.CORE_SEATS_ENTERPRISE];
export const getOwnedProductsThatRequireCoreSeat = ownedProducts => {
  const ownedProductsThatRequireCoreSeat = [];
  for (const product of ownedProducts) {
    if (VALID_API_NAMES_FOR_CORE_SEAT.includes(product.productApiName)) {
      ownedProductsThatRequireCoreSeat.push(product.productApiName);
    }
  }
  return ownedProductsThatRequireCoreSeat;
};